import { ApiResponse } from '@/shared/types';
import { axiosClient } from '@/shared/apis/config';
import { useQuery } from '@tanstack/react-query';
import { CustomQueryOptions } from '@/shared/types/global/react-query/query';
import { z } from 'zod';
import { DtoBrandTemplateType } from '@/shared/constants';
import { brandTemplateSchema } from '@/features/brand-template/model/brand-template';

export const GetBrandTemplatesResponseSchema = z.object({
  id: z.number(),
  tenantId: z.number(),
  creatorAccountId: z.number(),
  type: z.nativeEnum(DtoBrandTemplateType),
  name: z.string(),
  seq: z.number(),
  isActive: z.boolean(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  payload: brandTemplateSchema,
  accountBrandTemplateId: z.number(),
});

export type GetBrandTemplatesResponse = z.infer<
  typeof GetBrandTemplatesResponseSchema
>;

export type response = ApiResponse<GetBrandTemplatesResponse[]>;

export const getBrandTemplatesApi = async () => {
  try {
    const response = await axiosClient.get<response>('/v1.1/brand-templates');

    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const QueryKeyUseGetBrandTemplatesApi =
  'queryKeyUseGetBrandTemplatesApi' as const;

export const useGetBrandTemplatesApi = (
  options?: CustomQueryOptions<response>,
) => {
  const { queryKey, ...rest } = options ?? {};

  return useQuery({
    queryKey: [QueryKeyUseGetBrandTemplatesApi, queryKey],
    queryFn: async () => await getBrandTemplatesApi(),
    ...rest,
  });
};
